const Fuse = require('fuse.js')

const baseOption = {
  shouldSort: true,
  includeScore: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  tokenize: true
}

/**
  * Use Fuse.js for searching
  * @param options Options for Fuse.js.
  * @param list The data.
  * @param keyword The result will related this word.
  * @param size The limit of result list, defualt is 10.
  */
const search = function (options, list, keyword) {
  const fuse = new Fuse(list, options);
  return fuse.search(keyword)
}

const searchStock = function (keyword, stocks) {
  let options = baseOption
  options.keys = [
    {
      name: 'name',
      weight: 0.7
    },
    {
      name: 'thName',
      weight: 0.3
    },
    {
      name: 'enName',
      weight: 0.3
    }
  ]

  return search(options, stocks, keyword)
};

const searchFund = function (keyword, funds) {
  let options = baseOption
  options.keys = [
    {
      name: 'short_code',
      weight: 0.7
    },
    {
      name: 'name_th',
      weight: 0.3
    }
  ]

  return search(options, funds, keyword)
};

const searchIndice = function (keyword, funds) {
  let options = baseOption
  options.keys = [
    {
      name: 'IndexSymbol',
      weight: 0.7
    },
    {
      name: 'SectorNameTh',
      weight: 0.3
    },
    {
      name: 'SectorNameEn',
      weight: 0.3
    }
  ]

  return search(options, funds, keyword)
};

export {
  searchStock,
  searchFund,
  searchIndice
}